
      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("7rQws", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.init = void 0;
// ====================================================================================
// scrollytellingVideo.module.js
// ====================================================================================
var $56c3cbe036b95879$var$bgVideos = document.querySelectorAll(".scrollytelling-page .bg-video");
var $56c3cbe036b95879$var$videoSources = [];
var $56c3cbe036b95879$var$init = module.exports.init = function init() {
    $56c3cbe036b95879$var$bgVideos.forEach(function(video) {
        var videoSource = video.getAttribute("data-src");
        if (videoSource && $56c3cbe036b95879$var$videoSources.indexOf(videoSource) === -1) $56c3cbe036b95879$var$videoSources.push(videoSource);
    });
    var attempts = 0;
    var _whenComplete = function whenComplete() {
        if (++attempts > 30) return;
        if (document.readyState === "complete") $56c3cbe036b95879$var$videoSources.forEach(function(videoSource) {
            var video = document.createElement("video");
            video.width = 1920;
            video.height = 1080;
            video.autoplay = true;
            video.loop = true;
            video.playsInline = true;
            video.muted = true;
            video.classList.add("background", "video");
            var sourceElem = document.createElement("source");
            sourceElem.src = videoSource;
            sourceElem.type = "video/mp4";
            video.appendChild(sourceElem);
            var idx = 0;
            $56c3cbe036b95879$var$bgVideos.forEach(function(srcVideo, index) {
                var parent = srcVideo.parentElement;
                var elSource = srcVideo.getAttribute("data-src");
                if (elSource === videoSource) {
                    if (index === 0) parent.appendChild(video);
                    else {
                        var canvas = document.createElement("canvas");
                        canvas.classList.add("background", "video");
                        canvas.width = 1920;
                        canvas.height = 1080;
                        parent.appendChild(canvas);
                        var interval = setInterval(function() {
                            if (!video.paused && !video.ended) canvas.getContext("2d").drawImage(video, 0, 0);
                            else video.play();
                        }, 1000 / 30);
                    // clearInterval(interval);
                    }
                    idx++;
                }
            });
        });
        else setTimeout(function() {
            return _whenComplete();
        }, 400);
    };
    _whenComplete();
};

});


//# sourceMappingURL=scrollytellingVideos.module.070822c0.js.map
